import type { Id } from './Id';

export const RoleName = {
  ADMIN: 'admin',
  WAREHOUSEMAN: 'warehouseman',
  VENDOR: 'vendor',
} as const;

export type RoleName = typeof RoleName[keyof typeof RoleName];

export interface Role {
  roleName: RoleName;
}

export interface User {
  id: Id;
  name: string;
  email: string;
  roles: Role[];
}
